import React from "react";
import {
  Info,
  MoreHorizontal,
  ThumbsUp,
  MessageSquare,
  Repeat,
  Smile,
  Image,
  ChevronDown,
} from "lucide-react";
import { FaGlobeAfrica } from "react-icons/fa";


const CompanyPosts = () => {
  const goodFridayImageUrl =
    "https://images.pexels.com/photos/6590699/pexels-photo-6590699.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2";
  return (
    <>
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="max-w-xl mx-auto bg-white rounded-lg shadow-sm border border-gray-200">
          {/* Boost Banner */}
          <div className="flex items-center justify-between py-2 px-4 border-b border-gray-200">
            <div className="flex items-center gap-1 text-sm text-gray-900">
              <span>
                Get up to 240,000 more impressions by boosting this post.
              </span>
              <Info size={16} className="text-gray-500" />
            </div>
            <button className="font-semibold px-4 py-1 border border-blue-500 rounded-full text-blue-600 text-sm hover:bg-blue-50 transition-colors">
              Boost
            </button>
          </div>

          {/* Post Header */}
          <div className="">
            <div className="px-4">
            <div className="py-3 border-b-[1px]">
            <p className="text-sm text-gray-500">
                    By <span className="font-semibold">Manish Shrimal</span> • 4/18/2025
                  </p>
                  </div>
                  </div>
            <div className="px-4 pt-4 flex justify-between">
              <div className="flex gap-3">
                <div className="h-12 w-12 bg-purple-100 rounded-md flex items-center justify-center text-xs font-bold text-purple-800">
                  JS
                </div>
                <div>
                  
                  <h3 className="font-semibold text-gray-800">
                    LogicSpice Consultancy Private Ltd.
                  </h3>
                  <div className="text-xs text-gray-500 gap-1">
                    <span>3,359 followers</span>
                    
                    <p className="flex items-center gap-1">6d <span>•</span><FaGlobeAfrica />
                    </p>
                    
                  </div>
                </div>
              </div>
              <button className="h-8 w-8 flex items-center justify-center rounded-full hover:bg-gray-100">
                <MoreHorizontal size={20} className="text-gray-500" />
              </button>
            </div>
          </div>

          {/* Post Content */}
          <div className="px-4 py-2">
            <p className="text-sm text-gray-800 mb-1">
              <span role="img" aria-label="lightbulb">
                💡
              </span>{" "}
              On this Good Friday, let's pause, reflect, and reboot our hearts
              with kindness and hope.
            </p>
            <p className="text-sm text-gray-800 mb-3">
              Wishing you a meaningful day from the Logicspice family!
              <span role="img" aria-label="plant">
                🌱
              </span>
              <span role="img" aria-label="gift">
                🎁
              </span>
              <span role="img" aria-label="heart">
                💙
              </span>
              <span className="text-gray-500 cursor-pointer hover:underline">
                {" "}
                ...more
              </span>
            </p>
            <div className="overflow-hidden rounded-md mb-3">
              <img
                src={goodFridayImageUrl}
                alt="Good Friday"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Post Interactions */}
          <div className="px-2 py-1">
            <div className="flex justify-between items-center border-t border-b border-gray-200 py-1">
              <button className="flex items-center justify-center p-2 rounded-md hover:bg-gray-100 gap-1 text-sm text-gray-600 font-medium flex-1">
                <ThumbsUp size={18} />
                <span>Like</span>
              </button>
              <button className="flex items-center justify-center p-2 rounded-md hover:bg-gray-100 gap-1 text-sm text-gray-600 font-medium flex-1">
                <MessageSquare size={18} />
                <span>Comment</span>
              </button>
              <button className="flex items-center justify-center p-2 rounded-md hover:bg-gray-100 gap-1 text-sm text-gray-600 font-medium flex-1">
                <Repeat size={18} />
                <span>Repost</span>
              </button>
            </div>

            <div className="flex items-center mt-3 mb-3 px-2 py-2 rounded-full border border-gray-300 bg-gray-50">
              <div className="flex-1">
                <span className="text-gray-500 text-sm">
                  Comment as LogicSpice Consultancy Private Ltd....
                </span>
              </div>
              <div className="flex gap-2">
                <button className="p-1 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-200">
                  <Smile size={20} />
                </button>
                <button className="p-1 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-200">
                  <Image size={20} />
                </button>
              </div>
            </div>
          </div>

          {/* Post Stats */}
          <div className="flex justify-between items-center px-4 py-2 text-sm text-gray-600">
            <div>Organic impressions: 54 impressions</div>
            <button className="flex items-center gap-1 text-gray-700 font-medium">
              Preview results
              <ChevronDown size={16} />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyPosts;
